import L from "leaflet";

export const boatIcon = new L.Icon({
  iconUrl: "/boat.png",
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

export const homeIcon = new L.Icon({
  iconUrl: "/home.png",
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

// Recycling / ship-breaking yards: a plain square pin, styled in App.css (.yard-pin)
export const yardIcon = L.divIcon({
  className: "",
  html: '<div class="yard-pin"></div>',
  iconSize: [22, 22],
  iconAnchor: [11, 11],
  popupAnchor: [0, -12],
});
